import { request } from '../index'

export function createSale(sale) {
    return request({ url: "sales/", data: sale, method: "POST" })
}
export function getSale(id) {
    return request({ "url": `sales/${id}/` })
}
export function filterSales(params = {}) {
    return request({ "url": "sales/", params })
}
export function getResumePayments() {
    return request({ "url": `sales/resume-payments/` })
}
export function getSalesMonthPerDay() {
    return request({ "url": `sales/sales-month-per-day/` })
}
export function getAnnualSales(params = {}) {
    return request({ "url": `sales/annual-sales/`, params })
}

export function cancelSale(id, params = {}) {
    return request({ "url": `sales/${id}/`, "method": "DELETE", params })
}
export function getConfig(){
    return request({ "url": `branch-config/` })
}
export function updateConfig(data){
    return request({ "url": `branch-config/${data.id}/`, method: "PUT", data })
}


// WEBPACK FOOTER //
// ./src/api/sales/index.js